<template>
	<div class="select__container">
		<label class="select__label">
			<span v-if="label != ''" class="select__label-text">{{ label }}</span>
			<select
				:class="[
					'formtext',
					'select',
					label ? 'select--with-label' : true,
					lightTheme ? 'select--lightTheme' : '',
					small ? 'select--small' : true,
					value > 0 ? 'select--selected' : '',
					hasError ? 'select--error' : '',
					filterTheme ? 'select--filter' : ''
				]"
				:disabled="isDisabled"
				@change="emit($event.target.value)"
			>
				<option
					:disabled="this.defaultDisabled"
					:selected="defaultSelectedValue ? false : true"
					:value="''"
				>
					{{ placeholder }}
				</option>
				<option
					v-for="item in optionItems"
					:value="item.id"
					:key="item.id"
					:selected="item.id == value"
				>
					{{ item.text }}
				</option>
			</select>

			<span>
				<svg width="14" height="7" viewBox="0 0 14 7" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7 7a.998.998 0 01-.64-.232l-6-5A1.001 1.001 0 011.64.232l5.36 4.466L12.358.232a1.001 1.001 0 011.282 1.536l-6 5a.998.998 0 01-.64.232" fill-rule="evenodd"/></svg>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'Select',
	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		optionItems: {
			type: Array,
			default: () => []
		},
		defaultSelectedValue: {
			type: String,
			default: ''
		},
		defaultDisabled: {
			type: Boolean,
			default: true
		},
		placeholder: {
			type: String,
			default: 'Välj'
		},
		lightTheme: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		filterTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		emit(val) {
			this.$emit('input', val)
		}
	}
}
</script>

<style scoped lang="scss">
.select__container {
	display: flex;
}
.select__label {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	width: 100%;
	&-text {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 5px;
	}
}
.select {
	cursor: pointer;
	outline: 0;
	background: $colorInputBackground;
	border: 0;
	border-radius: 5px;
	color: $colorInputText;
	padding: 0 50px 0px 12px;
	height: $input-field-height;
	@include for-tablet-portrait-up {
		font-size: 16px;
		line-height: 33px;
	}
	min-width: 100px;
	width: 100%;
	appearance: none;
	-moz-appearance: none;
	-webkit-appearance: none;

	&::-ms-expand {
		display: none;
	}

	&::placeholder {
		font-weight: 300;
		color: #7f8ba1;
	}

	&:disabled {
		background: $colorGrey1;
		cursor: context-menu;
	}
	&:disabled::placeholder {
		color: $colorPrimary3;
	}
	&:disabled + span {
		svg {
			fill: $colorPrimary3;
		}
	}
	+ span {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 50px;
		height: $input-field-height;
		@include for-tablet-portrait-up {
			width: 46px;
		}
		background: $colorPrimary2;
		right: 0;
		pointer-events: none;
		border-radius: 0 5px 5px 0;
		svg {
			width: 14px;
			height: 11px;
			fill: $colorWhite;
		}
	}
	&--with-label {
		+ span {
			top: 29px;
		}
	}
	// &--filter {
	// 	@include for-phone-only {
	// 		background: $colorWhite;
	// 		border: 1px solid $colorPrimary3;
	// 		+ span {
	// 			background: transparent;
	// 			svg {
	// 				fill: $colorPrimary3;
	// 			}
	// 		}
	// 	}
	// }

	&--lightTheme {
		background: $colorWhite;
		border: 1px solid $colorPrimary3;
		+ span {
			background: transparent;
			svg {
				fill: $colorPrimary3;
			}
		}
		// &:disabled {
		// 	border-color: $colorPrimary3;
		// 	color: $colorPrimary5;
		// }
	}
	&--small {
		height: 35px;
		padding: 0 35px 0 15px;
		font-size: 16px;
		+ span {
			width: 35px;
			height: 35px;
		}
	}
	&--error {
		color: $colorWhite;
		background: $colorRed;
	}
	&--error + span {
		background: $colorAltRed;
	}
}
</style>
